// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__qnTvq","row":"Node_row__34oii","label":"Node_label__1jj0m","footer":"Node_footer__3cZL6"};